import { Component, OnInit } from '@angular/core';
import { StatsAndReportsService } from '@admin/stats-and-reports/shared/services/stats-and-reports.service';
import { SuspendedEmailAddress } from '../shared/models/suspended-email-address';
import { LazyLoadEvent, SelectItem } from 'primeng/api';
import { ConfigurationService } from '../../shared/services/configuration.service';
import { UserType } from '@admin/shared/models/user-type.enum';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-suspended-emails',
  templateUrl: './suspended-emails.component.html',
  styleUrls: ['./suspended-emails.component.less'],
  standalone: false,
})
export class SuspendedEmailsComponent implements OnInit {
  public emails: SuspendedEmailAddress[];
  public totalCount: number;

  public userTypes: SelectItem[];

  public pageSize: number;
  public pagingInfo: { start: number; limit: number };
  public sortParameters: { column: string; order: string }[];
  public emailFilter: string;
  public userTypeFilter: UserType;

  constructor(
    private statsAndReportsService: StatsAndReportsService,
    private config: ConfigurationService,
    private translateService: TranslateService
  ) {
    this.userTypes = [];
    this.emails = [];
    this.pagingInfo = { start: null, limit: null };
    this.sortParameters = [];
    this.emailFilter = null;
    this.userTypeFilter = null;
  }

  onLoad(event: LazyLoadEvent) {
    if (event.sortField && event.sortOrder) {
      this.sortParameters = [
        {
          column: event.sortField,
          order: event.sortOrder == 1 ? 'asc' : 'desc',
        },
      ];
    }
    this.pagingInfo.start = event.first;
    this.pagingInfo.limit = event.rows;
    this.onFilter();
  }

  onFilter() {
    this.statsAndReportsService
      .getSuspendedEmails(
        this.pagingInfo,
        this.sortParameters,
        this.emailFilter,
        this.userTypeFilter
      )
      .subscribe((emails) => {
        this.emails = emails.items;
        this.totalCount = emails.totalCount;
      });
  }

  onProcessClick(email: SuspendedEmailAddress) {
    this.statsAndReportsService
      .processSuspendedEmail(email.suspendedEmailAddressId)
      .subscribe(() => {
        this.onFilter();
      });
  }

  ngOnInit() {
    let config = this.config.getCachedConfig();
    this.pageSize = config.defaultPageSize;
    this.InitDropdowns();
  }

  private InitDropdowns() {
    this.userTypes = [
      {
        label: this.translateService.instant('label.Jobseeker'),
        value: UserType.Jobseeker,
      },
      {
        label: this.translateService.instant('label.CustomerAgent'),
        value: UserType.CustomerAgent,
      },
      {
        label: this.translateService.instant('label.Subscriber'),
        value: UserType.Anonymous,
      },
    ];
  }
}
